import screen from './Campaigns';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/client/campaigns/index.js